import {CompetitorLogoParams} from "../../../../domain/common/competitor/models/competitor-logo-params";
import {AppTerms} from "../../../app/app-terms";
import {CompetitorMetadataModel} from "../../../../domain/common/competitor/models/competitor-metadata-model";
import {GameCompetitorDomainModel} from "../../../../domain/partial-game/models/game-competitor/game-competitor-domain-model";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {GAME_CARD} from "../game-card.consts";
import {computed, makeObservable} from 'mobx';

export class GameCardCompetitorViewModel extends CompetitorViewModel {
  domainModel: GameCompetitorDomainModel;

  constructor(competitor: GameCompetitorDomainModel, terms: AppTerms, isSmallView: Boolean) {
    super(competitor);

    this.terms = terms;
    this.isSmallView = isSmallView;

    makeObservable(this);
  }

  get logo(): CompetitorLogoParams {
    const metadata: CompetitorMetadataModel = new CompetitorMetadataModel(this.domainModel, this.terms);
    const logo = new this.logoType({
      alt: metadata.alt,
      title: metadata.title,
      width: this.isSmallView ? GAME_CARD.ICONS_SIZES.COMPETITOR_LOGO.mobileSize : GAME_CARD.ICONS_SIZES.COMPETITOR_LOGO.desktopSize,
      height: this.isSmallView ? GAME_CARD.ICONS_SIZES.COMPETITOR_LOGO.mobileSize : GAME_CARD.ICONS_SIZES.COMPETITOR_LOGO.desktopSize,
      device: {
        isSmallView: this.isSmallView
      }
    }, this.domainModel);

    return logo;
  }

  get toQualify(): Boolean {
    return this.domainModel.toQualify;
  }

  get isQualified(): Boolean {
    return this.domainModel.isQualified;
  }

  get isWinner(): Boolean {
    return this.domainModel.isWinner;
  }

  get hasRedCards(): Boolean {
    return this.domainModel.redCards > 0;
  }

  get redCardsLabel(): Boolean {
    return this.domainModel.redCards > 1 ? this.domainModel.redCards : '';
  }

  get name(): String {
    return this.domainModel.shortName || this.domainModel.name;
  }

  get nameForUrl(): String {
    return this.domainModel.nameForUrl;
  }

  @computed get score(): Number {
    return this.domainModel.score !== -1 ? this.domainModel.score : '';
  }

  get seriesScore(): Number {
    return this.domainModel.seriesScore
  }

  get aggregatedScore(): Number {
    return this.domainModel.aggregatedScore
  }

  get penaltyScore(): Number {
    return this.domainModel.penaltyScore
  }
}
